import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ActivePeriod, ReportState } from 'features/reports/types';
import dayjs from 'utils/moment/dayjsConfig';

const ACTIVE_PERIOD_STORAGE_KEY = 'reports.activePeriod';

const loadPersistedActivePeriod = (): ActivePeriod | null => {
  try {
    const raw = localStorage.getItem(ACTIVE_PERIOD_STORAGE_KEY);
    return raw ? (JSON.parse(raw) as ActivePeriod) : null;
  } catch {
    return null;
  }
};

const persistActivePeriod = (period: ActivePeriod) => {
  try {
    localStorage.setItem(ACTIVE_PERIOD_STORAGE_KEY, JSON.stringify(period));
  } catch {
    // ignore
  }
};

const previousWeekDay = dayjs().subtract(1, 'week');

const initialActivePeriod: ActivePeriod = loadPersistedActivePeriod() ?? {
  type: 'WEEK',
  year: previousWeekDay.year(),
  week: previousWeekDay.week(),
};

const initialState: ReportState = {
  selectedPortId: null,
  activePeriod: initialActivePeriod,
};

const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    setSelectedPortId(state, action: PayloadAction<string | null>) {
      state.selectedPortId = action.payload;
    },
    setActivePeriod(state, action: PayloadAction<ActivePeriod>) {
      state.activePeriod = action.payload;
      persistActivePeriod(action.payload);
    },
  },
});

export const { setSelectedPortId, setActivePeriod } = reportsSlice.actions;
export default reportsSlice.reducer;
